export default __webpack_public_path__ + "e5c3db1764d7cde690e67d325a9b8377.svg";